import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ActiveProduct } from '../../types/activeProduct';
import { type CheckActiveResult, activeProductsService } from './services';

export const fetchActiveProducts = createAsyncThunk<ActiveProduct[]>(
  'activeProducts/fetchActive',
  async (_, { rejectWithValue }) => {
    try {
      return await activeProductsService.fetchActive();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const checkActiveContract = createAsyncThunk<
  CheckActiveResult,
  { productId: string; workspaceId: string }
>('activeProducts/checkActive', async ({ productId, workspaceId }, { rejectWithValue }) => {
  try {
    return await activeProductsService.checkActiveContract(productId, workspaceId);
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});
